import {Container}        from '@/domains/marketing/components/Container';
import PrimaryLayout      from '@/domains/marketing/layouts/PrimaryLayout';
import GradientTransition from '@/domains/shared/components/GradientTransition';
import {HeartIcon}        from '@heroicons/react/24/solid';
import classNames         from 'classnames';
import {Fragment}         from 'react';

export default function TechStack() {
	const categories = [
		{
			name:         'Backend',
			description:  'We specialize in crafting robust backend systems that power your websites and apps, ensuring seamless data management and top-tier security.',
			technologies: [
				{
					name:        'Laravel',
					description: 'At Atlas Software, we champion Laravel for its elegant simplicity and robust ecosystem, enabling us to craft powerful and visually appealing applications.\n\nIts modern PHP standards and scalable architecture make it ideal for projects of any size, ensuring maintainability and performance. Laravel’s extensive security features provide the reassurance of developing secure applications.\n\nIn essence, Laravel aligns perfectly with our dedication to delivering high-quality, efficient, and client-focused web solutions.',
					icon:        (props) => (<svg viewBox="0 0 256 264"
					                              {...props}>
						<path d="m255.9 59.6.1 1.1v56.6c0 1.4-.8 2.8-2 3.5l-47.6 27.4v54.2c0 1.4-.7 2.8-2 3.5l-99.1 57-.7.4-.3.1c-.7.2-1.4.2-2.1 0l-.4-.1-.6-.3L2 206c-1.3-.8-2.1-2.2-2.1-3.6V32.7l.1-1.1.2-.4.3-.6.2-.4.4-.5.4-.3c.2 0 .3-.2.5-.3L51.6.6c1.3-.8 2.9-.8 4.1 0L105.3 29c.2 0 .3.2.4.3l.5.3c0 .2.2.4.3.5l.3.4.3.6.1.4.2 1v106l41.2-23.7V60.7c0-.4 0-.7.2-1l.1-.4.3-.7.3-.3.3-.5.5-.3.4-.4 49.6-28.5c1.2-.7 2.8-.7 4 0L254 57l.5.4.4.3.4.5.2.3c.2.2.2.5.3.7l.2.3Zm-8.2 55.3v-47l-17.3 10-24 13.7v47l41.3-23.7Zm-49.5 85v-47l-23.6 13.5-67.2 38.4v47.5l90.8-52.3ZM8.2 39.9V200l90.9 52.3v-47.5l-47.5-26.9-.4-.4c-.2 0-.3-.1-.4-.3l-.4-.4-.3-.4-.2-.5-.2-.5v-.6l-.2-.5V63.6L25.6 49.8l-17.3-10Zm45.5-31L12.4 32.8l41.3 23.7 41.2-23.7L53.7 8.9ZM75 157.3l24-13.8V39.8l-17.3 10-24 13.8v103.6l17.3-10ZM202.3 36.9 161 60.7l41.3 23.8 41.3-23.8-41.3-23.8Zm-4.1 54.7-24-13.8-17.3-10v47l24 13.9 17.3 10v-47Zm-95 106 60.6-34.5 30.2-17.3-41.2-23.8-47.5 27.4L62 174.3l41.2 23.3Z"
						      fill="#FF2D20"
						/>
					</svg>),
					className:   'lg:col-span-3',
					featured:    true,
				},
				{
					name:        'Inertia',
					description: 'Integrates server-side and client-side frameworks for smooth web app development.',
					icon:        (props) => (<svg viewBox="0 0 275.3 50.5"
					                              {...props}
					>
						<path d="M231.2 16.1h-17.8l17.2 17.2-17.2 17.2h17.8l17.2-17.2z"
						      fill="#000"
						></path>
						<path d="M258.1 16.1h-17.8l17.2 17.2-17.2 17.2h17.8l17.2-17.2z"
						      fill="#000"
						></path>
						<path d="M6 15.3h10.3l-6 34.2H0l6-34.2zm.6-9.1C7.2 2.9 10.3 0 13.7 0s5.7 2.8 5.2 6.2c-.5 3.4-3.7 6.2-7.2 6.2s-5.6-3-5.1-6.2zM54.3 28.5l-3.7 21H40.4L43.8 30c.8-4.4-1.6-6.2-4.9-6.2-3.4 0-6.5 2-7.5 6.6L28 49.5H17.8l6-34.2h10.3l-.5 3.2c2.3-2.6 6.2-4.2 10.1-4.2 6.9.1 12.2 5.1 10.6 14.2zM94.5 32.4c-.1.8-.5 2.7-1.1 4.1H68.9c.6 3.8 3.8 4.8 7 4.8 2.9 0 5.2-.8 7.2-2.7l7.2 5.9c-4 4-8.7 6-15 6-11.8 0-18-8.5-16.3-18.7a20.7 20.7 0 0 1 20.5-17.4c9.8 0 16.9 7.6 15 18zm-9.7-3.7c-.3-3.8-3-5.3-6.2-5.3a8.9 8.9 0 0 0-8.3 5.3h14.5zM123.9 14.6l-2 11.6c-4-.6-10.5.8-11.7 7.8l.1-.4-2.8 15.9H97.3l6-34.2h10.3l-1.1 6.2c2.1-4.7 6.6-6.9 11.4-6.9zM137.8 37.3c-.5 3.1 2 3.3 6.6 2.9l-1.6 9.3c-12.3 1.4-16.9-2.7-15.2-12.2l2.1-12.1h-5.5l1.8-9.9h5.4l1.2-6.5 10.8-3.1-1.7 9.6h7.1l-1.8 9.9h-7l-2.2 12.1zM155.3 15.3h10.3l-6 34.2h-10.3l6-34.2zm.6-9.1c.5-3.3 3.7-6.2 7.1-6.2s5.7 2.8 5.2 6.2c-.5 3.4-3.7 6.2-7.2 6.2s-5.7-3-5.1-6.2zM208.1 15.3l-6 34.2h-10.3l.4-2.3a15.5 15.5 0 0 1-10.3 3.3c-11.1 0-15.3-9.6-13.5-18.9 1.6-8.8 8.6-17.2 19.2-17.2 4.5 0 7.7 1.8 9.6 4.6l.6-3.6h10.3zm-13.2 17.2c.9-5.2-1.9-8.4-6.6-8.4a9.5 9.5 0 0 0-9.5 8.3c-.9 5.1 1.8 8.3 6.6 8.3 4.6.1 8.6-3.1 9.5-8.2z"
						      fill="#000"
						></path>
					</svg>),
					featured:    true,
				},
				{
					name:        'Livewire',
					description: 'Server-side rendering with reactive components for dynamic web applications.',
					icon:        (props) => (<svg viewBox="0 0 36.7 30"
					                              {...props}
					>
						<path fill="#FB70A9"
						      d="M34.8 27.7c-.7 1-1.2 2.3-2.6 2.3-2.3 0-2.5-3.6-4.8-3.6S25.2 30 22.9 30s-2.5-3.6-4.8-3.6-2.2 3.6-4.5 3.6-2.5-3.6-4.8-3.6S6.6 30 4.3 30c-.7 0-1.2-.4-1.7-.8-1.7-3-2.6-6.4-2.6-9.9C0 8.6 8.2 0 18.3 0c10.1 0 18.3 8.6 18.3 19.2.1 3.1-.6 5.9-1.8 8.5z"
						/>
						<path fill="#FB70A9"
						      d="M34.8 27.7c-.7 1-1.2 2.3-2.6 2.3-2.3 0-2.5-3.6-4.8-3.6S25.2 30 22.9 30s-2.5-3.6-4.8-3.6-2.2 3.6-4.5 3.6-2.5-3.6-4.8-3.6S6.6 30 4.3 30c-.7 0-1.2-.4-1.7-.8-1.7-3-2.6-6.4-2.6-9.9C0 8.6 8.2 0 18.3 0c10.1 0 18.3 8.6 18.3 19.2.1 3.1-.6 5.9-1.8 8.5z"
						/>
						<path d="M30.8 29.6c4.8-7.1 4.9-15.1.4-23.8 3.5 3.6 5.5 8.4 5.5 13.4 0 3-.7 5.9-1.9 8.4-.7 1-1.2 2.3-2.7 2.3-.5.1-.9 0-1.3-.3z"
						      fill="#e24ca6"
						/>
						<path d="M17.4 24c6.4 0 9.1-3.7 9.1-8.9C26.4 9.8 22.4 5 17.4 5S8.3 9.8 8.3 15.1c0 5.2 2.7 8.9 9.1 8.9z"
						      fill="#fff"
						/>
						<path d="M14.9 15.4c1.9 0 3.4-1.7 3.4-3.8 0-2.1-1.5-3.8-3.4-3.8s-3.4 1.7-3.4 3.8c0 2.1 1.5 3.8 3.4 3.8z"
						      fill="#030776"
						/>
						<path d="M14.4 12.5c.9 0 1.7-.8 1.7-1.7 0-1-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7s.7 1.7 1.7 1.7z"
						      fill="#fff"
						/>
					</svg>),
					featured:    false,
				},
			],
		},
		{
			name:         'Frontend',
			description:  'Our team excels in creating engaging and intuitive frontend designs, delivering a seamless user experience that reflects your brand\'s uniqueness.',
			technologies: [
				{
					name:        'Expo',
					description: 'Expo simplifies mobile app development with React Native and JavaScript.',
					icon:        (props) => (<svg viewBox="0 0 24 22"
					                              {...props}>
						<path d="M11.39 8.269c.19-.277.397-.312.565-.312.168 0 .447.035.637.312 1.49 2.03 3.95 6.075 5.765 9.06 1.184 1.945 2.093 3.44 2.28 3.63.7.714 1.66.269 2.218-.541.549-.797.701-1.357.701-1.954 0-.407-7.958-15.087-8.759-16.309C14.027.98 13.775.683 12.457.683h-.988c-1.315 0-1.505.297-2.276 1.472C8.392 3.377.433 18.057.433 18.463c0 .598.153 1.158.703 1.955.558.81 1.518 1.255 2.218.54.186-.19 1.095-1.684 2.279-3.63 1.815-2.984 4.267-7.029 5.758-9.06z"
						      fill="#000"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'Inertia',
					description: 'Integrates server-side and client-side frameworks for smooth web app development.',
					icon:        (props) => (<svg viewBox="0 0 275.3 50.5"
					                              {...props}
					>
						<path d="M231.2 16.1h-17.8l17.2 17.2-17.2 17.2h17.8l17.2-17.2z"
						      fill="#000"
						></path>
						<path d="M258.1 16.1h-17.8l17.2 17.2-17.2 17.2h17.8l17.2-17.2z"
						      fill="#000"
						></path>
						<path d="M6 15.3h10.3l-6 34.2H0l6-34.2zm.6-9.1C7.2 2.9 10.3 0 13.7 0s5.7 2.8 5.2 6.2c-.5 3.4-3.7 6.2-7.2 6.2s-5.6-3-5.1-6.2zM54.3 28.5l-3.7 21H40.4L43.8 30c.8-4.4-1.6-6.2-4.9-6.2-3.4 0-6.5 2-7.5 6.6L28 49.5H17.8l6-34.2h10.3l-.5 3.2c2.3-2.6 6.2-4.2 10.1-4.2 6.9.1 12.2 5.1 10.6 14.2zM94.5 32.4c-.1.8-.5 2.7-1.1 4.1H68.9c.6 3.8 3.8 4.8 7 4.8 2.9 0 5.2-.8 7.2-2.7l7.2 5.9c-4 4-8.7 6-15 6-11.8 0-18-8.5-16.3-18.7a20.7 20.7 0 0 1 20.5-17.4c9.8 0 16.9 7.6 15 18zm-9.7-3.7c-.3-3.8-3-5.3-6.2-5.3a8.9 8.9 0 0 0-8.3 5.3h14.5zM123.9 14.6l-2 11.6c-4-.6-10.5.8-11.7 7.8l.1-.4-2.8 15.9H97.3l6-34.2h10.3l-1.1 6.2c2.1-4.7 6.6-6.9 11.4-6.9zM137.8 37.3c-.5 3.1 2 3.3 6.6 2.9l-1.6 9.3c-12.3 1.4-16.9-2.7-15.2-12.2l2.1-12.1h-5.5l1.8-9.9h5.4l1.2-6.5 10.8-3.1-1.7 9.6h7.1l-1.8 9.9h-7l-2.2 12.1zM155.3 15.3h10.3l-6 34.2h-10.3l6-34.2zm.6-9.1c.5-3.3 3.7-6.2 7.1-6.2s5.7 2.8 5.2 6.2c-.5 3.4-3.7 6.2-7.2 6.2s-5.7-3-5.1-6.2zM208.1 15.3l-6 34.2h-10.3l.4-2.3a15.5 15.5 0 0 1-10.3 3.3c-11.1 0-15.3-9.6-13.5-18.9 1.6-8.8 8.6-17.2 19.2-17.2 4.5 0 7.7 1.8 9.6 4.6l.6-3.6h10.3zm-13.2 17.2c.9-5.2-1.9-8.4-6.6-8.4a9.5 9.5 0 0 0-9.5 8.3c-.9 5.1 1.8 8.3 6.6 8.3 4.6.1 8.6-3.1 9.5-8.2z"
						      fill="#000"
						></path>
					</svg>),
					featured:    true,
				},
				{
					name:        'Next',
					description: 'React framework for server-side rendering and static web generation.',
					icon:        (props) => (<svg viewBox="0 0 256 256"
					                              {...props}>
						<defs>
							<linearGradient id="next-c"
							                x1="55.633%"
							                x2="83.228%"
							                y1="56.385%"
							                y2="96.08%"
							>
								<stop offset="0%"
								      stopColor="#FFF"
								/>
								<stop offset="100%"
								      stopColor="#FFF"
								      stopOpacity="0"
								/>
							</linearGradient>
							<linearGradient id="next-d"
							                x1="50%"
							                x2="49.953%"
							                y1="0%"
							                y2="73.438%"
							>
								<stop offset="0%"
								      stopColor="#FFF"
								/>
								<stop offset="100%"
								      stopColor="#FFF"
								      stopOpacity="0"
								/>
							</linearGradient>
							<circle id="next-a"
							        cx="128"
							        cy="128"
							        r="128"
							/>
						</defs>
						<g>
							<circle cx="128"
							        cy="128"
							        r="128"
							        fill="#000"
							/>
							<path fill="url(#next-c)"
							      d="M212.634 224.028 98.335 76.8H76.8v102.357h17.228V98.68L199.11 234.446a128.433 128.433 0 0 0 13.524-10.418Z"
							/>
							<path fill="url(#next-d)"
							      d="M163.556 76.8h17.067v102.4h-17.067z"
							/>
						</g>
					</svg>),
				},
				{
					name:        'React',
					description: 'JavaScript library for building efficient and interactive user interfaces.',
					icon:        (props) => (<svg viewBox="0 0 256 228"
					                              {...props}>
						<path d="M210.483 73.824a171.49 171.49 0 0 0-8.24-2.597c.465-1.9.893-3.777 1.273-5.621 6.238-30.281 2.16-54.676-11.769-62.708-13.355-7.7-35.196.329-57.254 19.526a171.23 171.23 0 0 0-6.375 5.848 155.866 155.866 0 0 0-4.241-3.917C100.759 3.829 77.587-4.822 63.673 3.233 50.33 10.957 46.379 33.89 51.995 62.588a170.974 170.974 0 0 0 1.892 8.48c-3.28.932-6.445 1.924-9.474 2.98C17.309 83.498 0 98.307 0 113.668c0 15.865 18.582 31.778 46.812 41.427a145.52 145.52 0 0 0 6.921 2.165 167.467 167.467 0 0 0-2.01 9.138c-5.354 28.2-1.173 50.591 12.134 58.266 13.744 7.926 36.812-.22 59.273-19.855a145.567 145.567 0 0 0 5.342-4.923 168.064 168.064 0 0 0 6.92 6.314c21.758 18.722 43.246 26.282 56.54 18.586 13.731-7.949 18.194-32.003 12.4-61.268a145.016 145.016 0 0 0-1.535-6.842c1.62-.48 3.21-.974 4.76-1.488 29.348-9.723 48.443-25.443 48.443-41.52 0-15.417-17.868-30.326-45.517-39.844Zm-6.365 70.984c-1.4.463-2.836.91-4.3 1.345-3.24-10.257-7.612-21.163-12.963-32.432 5.106-11 9.31-21.767 12.459-31.957 2.619.758 5.16 1.557 7.61 2.4 23.69 8.156 38.14 20.213 38.14 29.504 0 9.896-15.606 22.743-40.946 31.14Zm-10.514 20.834c2.562 12.94 2.927 24.64 1.23 33.787-1.524 8.219-4.59 13.698-8.382 15.893-8.067 4.67-25.32-1.4-43.927-17.412a156.726 156.726 0 0 1-6.437-5.87c7.214-7.889 14.423-17.06 21.459-27.246 12.376-1.098 24.068-2.894 34.671-5.345.522 2.107.986 4.173 1.386 6.193ZM87.276 214.515c-7.882 2.783-14.16 2.863-17.955.675-8.075-4.657-11.432-22.636-6.853-46.752a156.923 156.923 0 0 1 1.869-8.499c10.486 2.32 22.093 3.988 34.498 4.994 7.084 9.967 14.501 19.128 21.976 27.15a134.668 134.668 0 0 1-4.877 4.492c-9.933 8.682-19.886 14.842-28.658 17.94ZM50.35 144.747c-12.483-4.267-22.792-9.812-29.858-15.863-6.35-5.437-9.555-10.836-9.555-15.216 0-9.322 13.897-21.212 37.076-29.293 2.813-.98 5.757-1.905 8.812-2.773 3.204 10.42 7.406 21.315 12.477 32.332-5.137 11.18-9.399 22.249-12.634 32.792a134.718 134.718 0 0 1-6.318-1.979Zm12.378-84.26c-4.811-24.587-1.616-43.134 6.425-47.789 8.564-4.958 27.502 2.111 47.463 19.835a144.318 144.318 0 0 1 3.841 3.545c-7.438 7.987-14.787 17.08-21.808 26.988-12.04 1.116-23.565 2.908-34.161 5.309a160.342 160.342 0 0 1-1.76-7.887Zm110.427 27.268a347.8 347.8 0 0 0-7.785-12.803c8.168 1.033 15.994 2.404 23.343 4.08-2.206 7.072-4.956 14.465-8.193 22.045a381.151 381.151 0 0 0-7.365-13.322Zm-45.032-43.861c5.044 5.465 10.096 11.566 15.065 18.186a322.04 322.04 0 0 0-30.257-.006c4.974-6.559 10.069-12.652 15.192-18.18ZM82.802 87.83a323.167 323.167 0 0 0-7.227 13.238c-3.184-7.553-5.909-14.98-8.134-22.152 7.304-1.634 15.093-2.97 23.209-3.984a321.524 321.524 0 0 0-7.848 12.897Zm8.081 65.352c-8.385-.936-16.291-2.203-23.593-3.793 2.26-7.3 5.045-14.885 8.298-22.6a321.187 321.187 0 0 0 7.257 13.246c2.594 4.48 5.28 8.868 8.038 13.147Zm37.542 31.03c-5.184-5.592-10.354-11.779-15.403-18.433 4.902.192 9.899.29 14.978.29 5.218 0 10.376-.117 15.453-.343-4.985 6.774-10.018 12.97-15.028 18.486Zm52.198-57.817c3.422 7.8 6.306 15.345 8.596 22.52-7.422 1.694-15.436 3.058-23.88 4.071a382.417 382.417 0 0 0 7.859-13.026 347.403 347.403 0 0 0 7.425-13.565Zm-16.898 8.101a358.557 358.557 0 0 1-12.281 19.815 329.4 329.4 0 0 1-23.444.823c-7.967 0-15.716-.248-23.178-.732a310.202 310.202 0 0 1-12.513-19.846h.001a307.41 307.41 0 0 1-10.923-20.627 310.278 310.278 0 0 1 10.89-20.637l-.001.001a307.318 307.318 0 0 1 12.413-19.761c7.613-.576 15.42-.876 23.31-.876H128c7.926 0 15.743.303 23.354.883a329.357 329.357 0 0 1 12.335 19.695 358.489 358.489 0 0 1 11.036 20.54 329.472 329.472 0 0 1-11 20.722Zm22.56-122.124c8.572 4.944 11.906 24.881 6.52 51.026-.344 1.668-.73 3.367-1.15 5.09-10.622-2.452-22.155-4.275-34.23-5.408-7.034-10.017-14.323-19.124-21.64-27.008a160.789 160.789 0 0 1 5.888-5.4c18.9-16.447 36.564-22.941 44.612-18.3ZM128 90.808c12.625 0 22.86 10.235 22.86 22.86s-10.235 22.86-22.86 22.86-22.86-10.235-22.86-22.86 10.235-22.86 22.86-22.86Z"
						      fill="#00D8FF"
						/>
					</svg>),
				},
				{
					name:        'React Native',
					description: 'Framework for building native mobile apps using React.',
					icon:        (props) => (<svg viewBox="0 0 256 228"
					                              {...props}>
						<path d="M210.483 73.824a171.49 171.49 0 0 0-8.24-2.597c.465-1.9.893-3.777 1.273-5.621 6.238-30.281 2.16-54.676-11.769-62.708-13.355-7.7-35.196.329-57.254 19.526a171.23 171.23 0 0 0-6.375 5.848 155.866 155.866 0 0 0-4.241-3.917C100.759 3.829 77.587-4.822 63.673 3.233 50.33 10.957 46.379 33.89 51.995 62.588a170.974 170.974 0 0 0 1.892 8.48c-3.28.932-6.445 1.924-9.474 2.98C17.309 83.498 0 98.307 0 113.668c0 15.865 18.582 31.778 46.812 41.427a145.52 145.52 0 0 0 6.921 2.165 167.467 167.467 0 0 0-2.01 9.138c-5.354 28.2-1.173 50.591 12.134 58.266 13.744 7.926 36.812-.22 59.273-19.855a145.567 145.567 0 0 0 5.342-4.923 168.064 168.064 0 0 0 6.92 6.314c21.758 18.722 43.246 26.282 56.54 18.586 13.731-7.949 18.194-32.003 12.4-61.268a145.016 145.016 0 0 0-1.535-6.842c1.62-.48 3.21-.974 4.76-1.488 29.348-9.723 48.443-25.443 48.443-41.52 0-15.417-17.868-30.326-45.517-39.844Zm-6.365 70.984c-1.4.463-2.836.91-4.3 1.345-3.24-10.257-7.612-21.163-12.963-32.432 5.106-11 9.31-21.767 12.459-31.957 2.619.758 5.16 1.557 7.61 2.4 23.69 8.156 38.14 20.213 38.14 29.504 0 9.896-15.606 22.743-40.946 31.14Zm-10.514 20.834c2.562 12.94 2.927 24.64 1.23 33.787-1.524 8.219-4.59 13.698-8.382 15.893-8.067 4.67-25.32-1.4-43.927-17.412a156.726 156.726 0 0 1-6.437-5.87c7.214-7.889 14.423-17.06 21.459-27.246 12.376-1.098 24.068-2.894 34.671-5.345.522 2.107.986 4.173 1.386 6.193ZM87.276 214.515c-7.882 2.783-14.16 2.863-17.955.675-8.075-4.657-11.432-22.636-6.853-46.752a156.923 156.923 0 0 1 1.869-8.499c10.486 2.32 22.093 3.988 34.498 4.994 7.084 9.967 14.501 19.128 21.976 27.15a134.668 134.668 0 0 1-4.877 4.492c-9.933 8.682-19.886 14.842-28.658 17.94ZM50.35 144.747c-12.483-4.267-22.792-9.812-29.858-15.863-6.35-5.437-9.555-10.836-9.555-15.216 0-9.322 13.897-21.212 37.076-29.293 2.813-.98 5.757-1.905 8.812-2.773 3.204 10.42 7.406 21.315 12.477 32.332-5.137 11.18-9.399 22.249-12.634 32.792a134.718 134.718 0 0 1-6.318-1.979Zm12.378-84.26c-4.811-24.587-1.616-43.134 6.425-47.789 8.564-4.958 27.502 2.111 47.463 19.835a144.318 144.318 0 0 1 3.841 3.545c-7.438 7.987-14.787 17.08-21.808 26.988-12.04 1.116-23.565 2.908-34.161 5.309a160.342 160.342 0 0 1-1.76-7.887Zm110.427 27.268a347.8 347.8 0 0 0-7.785-12.803c8.168 1.033 15.994 2.404 23.343 4.08-2.206 7.072-4.956 14.465-8.193 22.045a381.151 381.151 0 0 0-7.365-13.322Zm-45.032-43.861c5.044 5.465 10.096 11.566 15.065 18.186a322.04 322.04 0 0 0-30.257-.006c4.974-6.559 10.069-12.652 15.192-18.18ZM82.802 87.83a323.167 323.167 0 0 0-7.227 13.238c-3.184-7.553-5.909-14.98-8.134-22.152 7.304-1.634 15.093-2.97 23.209-3.984a321.524 321.524 0 0 0-7.848 12.897Zm8.081 65.352c-8.385-.936-16.291-2.203-23.593-3.793 2.26-7.3 5.045-14.885 8.298-22.6a321.187 321.187 0 0 0 7.257 13.246c2.594 4.48 5.28 8.868 8.038 13.147Zm37.542 31.03c-5.184-5.592-10.354-11.779-15.403-18.433 4.902.192 9.899.29 14.978.29 5.218 0 10.376-.117 15.453-.343-4.985 6.774-10.018 12.97-15.028 18.486Zm52.198-57.817c3.422 7.8 6.306 15.345 8.596 22.52-7.422 1.694-15.436 3.058-23.88 4.071a382.417 382.417 0 0 0 7.859-13.026 347.403 347.403 0 0 0 7.425-13.565Zm-16.898 8.101a358.557 358.557 0 0 1-12.281 19.815 329.4 329.4 0 0 1-23.444.823c-7.967 0-15.716-.248-23.178-.732a310.202 310.202 0 0 1-12.513-19.846h.001a307.41 307.41 0 0 1-10.923-20.627 310.278 310.278 0 0 1 10.89-20.637l-.001.001a307.318 307.318 0 0 1 12.413-19.761c7.613-.576 15.42-.876 23.31-.876H128c7.926 0 15.743.303 23.354.883a329.357 329.357 0 0 1 12.335 19.695 358.489 358.489 0 0 1 11.036 20.54 329.472 329.472 0 0 1-11 20.722Zm22.56-122.124c8.572 4.944 11.906 24.881 6.52 51.026-.344 1.668-.73 3.367-1.15 5.09-10.622-2.452-22.155-4.275-34.23-5.408-7.034-10.017-14.323-19.124-21.64-27.008a160.789 160.789 0 0 1 5.888-5.4c18.9-16.447 36.564-22.941 44.612-18.3ZM128 90.808c12.625 0 22.86 10.235 22.86 22.86s-10.235 22.86-22.86 22.86-22.86-10.235-22.86-22.86 10.235-22.86 22.86-22.86Z"
						      fill="#00D8FF"
						/>
					</svg>),
					featured:    false,
				},
				{
					name:        'Tailwind',
					description: 'A utility-first CSS framework for rapid UI development.',
					icon:        (props) => (<svg viewBox="0 0 256 154"
					                              {...props}>
						<defs>
							<linearGradient x1="-2.778%"
							                y1="32%"
							                x2="100%"
							                y2="67.556%"
							                id="tailwind-a"
							>
								<stop stopColor="#2298BD"
								      offset="0%"
								/>
								<stop stopColor="#0ED7B5"
								      offset="100%"
								/>
							</linearGradient>
						</defs>

						<path d="M128 0C93.867 0 72.533 17.067 64 51.2 76.8 34.133 91.733 27.733 108.8 32c9.737 2.434 16.697 9.499 24.401 17.318C145.751 62.057 160.275 76.8 192 76.8c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C174.249 14.743 159.725 0 128 0ZM64 76.8C29.867 76.8 8.533 93.867 0 128c12.8-17.067 27.733-23.467 44.8-19.2 9.737 2.434 16.697 9.499 24.401 17.318C81.751 138.857 96.275 153.6 128 153.6c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C110.249 91.543 95.725 76.8 64 76.8Z"
						      fill="url(#tailwind-a)"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'Vue',
					description: 'Progressive JavaScript framework for building user interfaces.',
					icon:        (props) => (<svg viewBox="0 0 256 221"
					                              {...props}>
						<path d="M204.8 0H256L128 220.8 0 0h97.92L128 51.2 157.44 0h47.36Z"
						      fill="#41B883"
						/>
						<path d="m0 0 128 220.8L256 0h-51.2L128 132.48 50.56 0H0Z"
						      fill="#41B883"
						/>
						<path d="M50.56 0 128 133.12 204.8 0h-47.36L128 51.2 97.92 0H50.56Z"
						      fill="#35495E"
						/>
					</svg>),
					featured:    true,
				},
			],
		},
		{
			name:         'Hosting',
			description:  'We provide reliable hosting solutions tailored to your project\'s needs, ensuring your website or application\'s high performance and constant online presence.',
			technologies: [
				{
					name:        'AWS',
					description: 'Comprehensive cloud platform offering scalable computing services.',
					icon:        (props) => (<svg viewBox="0 0 304 182"
					                              {...props}>
						<path d="m86 66 2 9c0 3 1 5 3 8v2l-1 3-7 4-2 1-3-1-4-5-3-6c-8 9-18 14-29 14-9 0-16-3-20-8-5-4-8-11-8-19s3-15 9-20c6-6 14-8 25-8a79 79 0 0 1 22 3v-7c0-8-2-13-5-16-3-4-8-5-16-5l-11 1a80 80 0 0 0-14 5h-2c-1 0-2-1-2-3v-5l1-3c0-1 1-2 3-2l12-5 16-2c12 0 20 3 26 8 5 6 8 14 8 25v32zM46 82l10-2c4-1 7-4 10-7l3-6 1-9v-4a84 84 0 0 0-19-2c-6 0-11 1-15 4-3 2-4 6-4 11s1 8 3 11c3 2 6 4 11 4zm80 10-4-1-2-3-23-78-1-4 2-2h10l4 1 2 4 17 66 15-66 2-4 4-1h8l4 1 2 4 16 67 17-67 2-4 4-1h9c2 0 3 1 3 2v2l-1 2-24 78-2 4-4 1h-9l-4-1-1-4-16-65-15 64-2 4-4 1h-9zm129 3a66 66 0 0 1-27-6l-3-3-1-2v-5c0-2 1-3 2-3h2l3 1a54 54 0 0 0 23 5c6 0 11-2 14-4 4-2 5-5 5-9l-2-7-10-5-15-5c-7-2-13-6-16-10a24 24 0 0 1 5-34l10-5a44 44 0 0 1 20-2 110 110 0 0 1 12 3l4 2 3 2 1 4v4c0 3-1 4-2 4l-4-2c-6-2-12-3-19-3-6 0-11 0-14 2s-4 5-4 9c0 3 1 5 3 7s5 4 11 6l14 4c7 3 12 6 15 10s5 9 5 14l-3 12-7 8c-3 3-7 5-11 6l-14 2z"
						      fill="#252f3e"
						/>
						<path fill="#f90"
						      d="M274 144A220 220 0 0 1 4 124c-4-3-1-6 2-4a300 300 0 0 0 263 16c5-2 10 4 5 8z"
						/>
						<path fill="#f90"
						      d="M287 128c-4-5-28-3-38-1-4 0-4-3-1-5 19-13 50-9 53-5 4 5-1 36-18 51-3 2-6 1-5-2 5-10 13-33 9-38z"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'Forge',
					description: 'A server management and deployment service for Laravel applications.',
					icon:        (props) => (<svg viewBox="0 0 109 21"
					                              {...props}>
						<path d="M38.971.659c2.062 0 3.013.37 3.595 1.11.846 1.11 1.322 3.33-.053 8.775s-2.907 7.613-4.335 8.776c-.952.74-2.115 1.11-4.176 1.11h-6.608c-2.062 0-3.066-.37-3.595-1.11-.846-1.11-1.322-3.33.106-8.776 1.374-5.445 2.96-7.612 4.388-8.775.952-.74 2.115-1.11 4.176-1.11h6.502zM29.35 15.619c.106.159.37.212 1.216.212h2.537c.846 0 1.163-.053 1.375-.212.264-.211.74-.74 1.797-5.075 1.11-4.335.899-4.863.74-5.075-.106-.159-.37-.211-1.216-.211h-2.485c-.846 0-1.163.053-1.374.211-.264.211-.74.74-1.797 5.075-1.163 4.388-.952 4.864-.793 5.075zm25.639-1.586c-.211-.264-.423-.37-1.692-.37h-2.485a.62.62 0 0 0-.581.476l-1.427 5.815a.62.62 0 0 1-.582.476h-5.128c-.264 0-.423-.212-.37-.476l4.705-18.82a.62.62 0 0 1 .582-.476h12.053c1.956 0 3.013.264 3.595 1.004.634.899.846 1.85.159 4.599-.899 3.701-2.273 4.758-4.652 5.234v.053c1.85.476 2.855 1.11 2.22 3.965l-.793 4.388c-.053.264-.317.529-.581.529h-5.234c-.212 0-.423-.159-.37-.423l.687-3.965c.211-1.427.106-1.692-.106-2.009zm-.37-4.652c1.11 0 1.427-.053 1.639-.211.37-.264.634-.74.899-1.903s.212-1.586 0-1.85c-.159-.159-.423-.211-1.533-.211h-2.749a.62.62 0 0 0-.581.476L51.5 8.958c-.053.264.106.476.37.476h2.749v-.053zM80.47.5c2.115 0 3.225.264 3.859 1.004.74.899 1.004 2.273.423 5.339a.62.62 0 0 1-.582.476h-4.916c-.264 0-.423-.211-.37-.423.212-1.216-.053-1.374-.212-1.586-.106-.159-.317-.211-1.216-.211h-2.537c-.899 0-1.163.053-1.374.211-.317.264-.899 1.163-1.85 5.181s-.793 4.969-.634 5.234c.106.159.37.211 1.269.211h2.696c.793 0 1.11-.053 1.322-.211.264-.211.793-.74 1.11-2.168l.053-.159h-3.806c-.264 0-.423-.211-.37-.476l.74-3.172a.62.62 0 0 1 .582-.476H83.8c.264 0 .423.211.37.476l-.476 1.956c-1.11 4.811-2.432 6.502-3.806 7.612-1.004.846-2.432 1.163-4.282 1.163h-6.608c-2.062 0-3.066-.37-3.648-1.163-.899-1.163-1.374-3.33-.053-8.828s2.855-7.718 4.282-8.828C70.531.87 71.694.5 73.756.5h6.714zm20.617 19.983H85.281c-.264 0-.423-.212-.37-.476L89.351.976A.62.62 0 0 1 89.933.5h18.396c.318 0 .476.317.265.634-.793 1.269-3.859 3.965-7.296 3.965h-6.396a.62.62 0 0 0-.581.476l-.476 2.115c-.053.264.106.476.37.476h8.616c.265 0 .423.211.371.476l-.741 3.33a.62.62 0 0 1-.581.476h-8.617a.62.62 0 0 0-.582.476l-.582 2.432c-.053.264.106.476.37.476h9.674c.265 0 .423.211.37.476l-.846 3.648c-.052.317-.317.529-.581.529zM25.121.659H3.446a.62.62 0 0 0-.582.476l-.529 1.903c-.053.211.053.37.211.476.846.264 5.392.37 4.705 2.908l-.159.687-1.85 6.925-.159.687c-.687 2.537-3.119 2.643-4.123 2.908-.211.053-.37.264-.423.476L.01 20.007c-.053.264.106.476.37.476h8.828a.62.62 0 0 0 .582-.476l1.586-6.132a.62.62 0 0 1 .582-.476h5.657a.62.62 0 0 0 .581-.476l.846-3.278c.053-.264-.106-.476-.37-.476h-5.656c-.264 0-.423-.211-.37-.476l.793-2.96a.62.62 0 0 1 .582-.476h8.511a.62.62 0 0 0 .581-.476l2.273-3.595c.106-.317 0-.529-.264-.529z"
						      fill="#000"
						></path>
					</svg>),
				},
				{
					name:        'Vapor',
					description: 'A serverless deployment platform for Laravel.',
					icon:        (props) => (<svg viewBox="0 0 40 40"
					                              fill="none"
					                              {...props}>
						<path d="M4.345 9h10.55L9.618 20 4.345 9zm21.099 0h10.55l-5.276 11-5.274-11z"
						      fill="#E9F9FD"
						      fillOpacity=".1"
						></path>
						<path d="M9.62 20h10.549l-5.275 11L9.62 20z"
						      fill="#25C4F2"
						      fillOpacity=".22"
						></path>
						<path d="M20.169 20h10.55l-5.275 11-5.275-11z"
						      fill="#25C4F2"
						      fillOpacity=".2"
						></path>
						<path d="M20.169 20H9.619l5.275-11 5.275 11z"
						      fill="#25C4F2"
						      fillOpacity=".4"
						></path>
						<path d="M30.718 20h-10.55l5.276-11 5.274 11z"
						      fill="#25C4F2"
						      fillOpacity=".4"
						></path>
						<path d="M25.444 31h-10.55l5.275-11 5.275 11z"
						      fill="#25C4F2"
						      fillOpacity=".5"
						></path>
						<path d="M3.494 8.467A1 1 0 0 1 4.34 8h10.55a1 1 0 0 1 .902.568l4.373 9.12 4.373-9.12A1 1 0 0 1 25.44 8h10.55a1 1 0 0 1 .902 1.432L26.345 31.424a1.001 1.001 0 0 1-.905.576H14.89a1 1 0 0 1-.902-.568l-10.55-22a1 1 0 0 1 .056-.965zm21.95 2.846L29.13 19h-7.372l3.686-7.687zM5.934 10l3.686 7.687L13.306 10H5.933zm8.96 1.313L18.58 19h-7.372l3.686-7.687zM27.032 10l3.686 7.687L34.405 10h-7.373zm-1.588 18.687L21.758 21h7.372l-3.686 7.687zM23.855 30l-3.686-7.687L16.483 30h7.372zm-8.96-1.313L11.207 21h7.372l-3.686 7.687z"
						      fill="#25C4F2"
						      fillRule="evenodd"
						      clipRule="evenodd"
						></path>
					</svg>),
					featured:    true,
				},
				{
					name:        'Vercel',
					description: 'Platform for frontend frameworks and static sites deployment.',
					icon:        (props) => (<svg viewBox="0 0 256 222"
					                              {...props}>
						<path d="m128 0 128 221.705H0z"
						      fill="#000"
						/>
					</svg>),
				},
			],
		},
		{
			name:         'Code and automation',
			description:  'Our approach integrates advanced coding practices with automation to enhance efficiency, reduce errors, and speed up project delivery, setting high standards in software development.',
			technologies: [
				{
					name:        'CloudFormation',
					description: 'AWS service for managing infrastructure with code.',
					icon:        (props) => (<svg viewBox="0 0 256 312"
					                              {...props}>
						<path d="m16.491 215.53 2.176 2.47 109.915 31.157.498-19.313-76.98-19.318-3.767-1.359z"
						      fill="#b7ca9d"
						/>
						<path d="m239.505 215.53-112.255 37.47-.334-23.156 76.979-19.318 3.355-3.776z"
						      fill="#b7ca9d"
						/>
						<path d="m126.916 83.165 76.979 17.941 33.855-1.606 1.755-3.393-107.255-38.607z"
						      fill="#3c4929"
						/>
						<path d="m52.1 210.526-35.609 5.004-.991-3.697v-111.833l.991-3.893 32.176 2.393 3.433 2.61z"
						      fill="#759c3e"
						/>
						<path d="m129.08 83.165-76.98 17.941-35.609-4.999 1.342-2.107 110.749-31.52z"
						      fill="#3c4929"
						/>
						<path d="m127.846 0-127.846 64.531.061 182.613 127.785 64.497 1.904-2.891v-305zm-37.384 237.73-73.971-22.2v-119.423l73.971-22.192z"
						      fill="#4b612c"
						/>
						<path d="m203.895 210.526 35.61 5.004 1.995-3.53v-112.5l-1.995-3.393-35.61 5.003z"
						      fill="#4b612c"
						/>
						<path d="m127.846 311.641 128.093-64.493.061-182.612-128.154-64.536zm37.687-237.726 73.972 22.192v119.423l-73.972 22.2z"
						      fill="#759c3e"
						/>
					</svg>),
				},
				{
					name:        'Envoyer',
					description: 'Zero-downtime deployment tool for Laravel applications.',
					icon:        (props) => (<svg viewBox="0 0 31.6 36.7"
					                              {...props}>
						<linearGradient id="envoyer-a"
						                gradientUnits="userSpaceOnUse"
						                x1="15.395"
						                y1="9"
						                x2="15.395"
						                y2="1.5"
						                gradientTransform="matrix(1 0 0 -1 0 37)"
						>
							<stop offset="0"
							      stopColor="#fa342c"
							/>
							<stop offset="1"
							      stopColor="#ff5a08"
							/>
						</linearGradient>
						<path d="M15.4 28v7.5"
						      fill="none"
						      stroke="url(#envoyer-a)"
						      strokeWidth="2.368"
						      strokeLinecap="round"
						/>
						<linearGradient id="envoyer-b"
						                gradientUnits="userSpaceOnUse"
						                x1="7.5"
						                y1="6.829"
						                x2="7.5"
						                y2="3.671"
						                gradientTransform="matrix(1 0 0 -1 0 37)"
						>
							<stop offset="0"
							      stopColor="#fa342c"
							/>
							<stop offset="1"
							      stopColor="#ff5a08"
							/>
						</linearGradient>
						<path d="M7.5 30.2v3.2"
						      fill="none"
						      stroke="url(#envoyer-b)"
						      strokeWidth="2.368"
						      strokeLinecap="round"
						/>
						<linearGradient id="envoyer-c"
						                gradientUnits="userSpaceOnUse"
						                x1="23.29"
						                y1="6.829"
						                x2="23.29"
						                y2="3.671"
						                gradientTransform="matrix(1 0 0 -1 0 37)"
						>
							<stop offset="0"
							      stopColor="#fa342c"
							/>
							<stop offset="1"
							      stopColor="#ff5a08"
							/>
						</linearGradient>
						<path d="M23.3 30.2v3.2"
						      fill="none"
						      stroke="url(#envoyer-c)"
						      strokeWidth="2.368"
						      strokeLinecap="round"
						/>
						<linearGradient id="envoyer-d"
						                gradientUnits="userSpaceOnUse"
						                x1="7.099"
						                y1="21.715"
						                x2="33.126"
						                y2="25.1"
						                gradientTransform="matrix(1 0 0 -1 0 37)"
						>
							<stop offset="0"
							      stopColor="#f9332b"
							/>
							<stop offset="1"
							      stopColor="#ff6100"
							/>
						</linearGradient>
						<path d="M19.6 2.1c-1.8-2.8-5.8-2.8-7.6 0L.7 19.8c-1.9 3 .2 7 3.8 7h2.6c2.4 0 4.5-1.4 5.5-3.5l.8-1.8c.7-1.6 2.9-1.6 3.6 0l.8 1.8c1 2.1 3.1 3.5 5.5 3.5H27c3.6 0 5.7-4 3.8-7L19.6 2.1z"
						      fill="url(#envoyer-d)"
						/>
					</svg>),
				},
				{
					name:        'GitHub',
					description: 'Platform for version control and collaborative software development.',
					icon:        (props) => (<svg viewBox="0 0 24 24"
					                              {...props}>
						<path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
						      fill="#000"
						/>
					</svg>),
				},
				{
					name:        'GitHub Actions',
					description: 'CI/CD and workflow automation tool integrated with GitHub.',
					icon:        (props) => (<svg viewBox="0 0 128 128"
					                              {...props}>
						<path fill="#2088ff"
						      d="M26.666 0C11.97 0 0 11.97 0 26.666c0 12.87 9.181 23.651 21.334 26.13v37.87c0 11.77 9.68 21.334 21.332 21.334h.195c1.302 9.023 9.1 16 18.473 16C71.612 128 80 119.612 80 109.334s-8.388-18.668-18.666-18.668c-9.372 0-17.17 6.977-18.473 16h-.195c-8.737 0-16-7.152-16-16V63.779a18.514 18.514 0 0 0 13.24 5.555h2.955c1.303 9.023 9.1 16 18.473 16 9.372 0 17.169-6.977 18.47-16h11.057c1.303 9.023 9.1 16 18.473 16 10.278 0 18.666-8.39 18.666-18.668C128 56.388 119.612 48 109.334 48c-9.373 0-17.171 6.977-18.473 16H79.805c-1.301-9.023-9.098-16-18.471-16s-17.171 6.977-18.473 16h-2.955c-6.433 0-11.793-4.589-12.988-10.672 14.58-.136 26.416-12.05 26.416-26.662C53.334 11.97 41.362 0 26.666 0zm0 5.334A21.292 21.292 0 0 1 48 26.666 21.294 21.294 0 0 1 26.666 48 21.292 21.292 0 0 1 5.334 26.666 21.29 21.29 0 0 1 26.666 5.334zm-5.215 7.541C18.67 12.889 16 15.123 16 18.166v17.043c0 4.043 4.709 6.663 8.145 4.533l13.634-8.455c3.257-2.02 3.274-7.002.032-9.045l-13.635-8.59a5.024 5.024 0 0 0-2.725-.777zm-.117 5.291 13.635 8.588-13.635 8.455V18.166zm40 35.168a13.29 13.29 0 0 1 13.332 13.332A13.293 13.293 0 0 1 61.334 80 13.294 13.294 0 0 1 48 66.666a13.293 13.293 0 0 1 13.334-13.332zm48 0a13.29 13.29 0 0 1 13.332 13.332A13.293 13.293 0 0 1 109.334 80 13.294 13.294 0 0 1 96 66.666a13.293 13.293 0 0 1 13.334-13.332zm-42.568 6.951a2.667 2.667 0 0 0-1.887.78l-6.3 6.294-2.093-2.084a2.667 2.667 0 0 0-3.771.006 2.667 2.667 0 0 0 .008 3.772l3.974 3.96a2.667 2.667 0 0 0 3.766-.001l8.185-8.174a2.667 2.667 0 0 0 .002-3.772 2.667 2.667 0 0 0-1.884-.78zm48 0a2.667 2.667 0 0 0-1.887.78l-6.3 6.294-2.093-2.084a2.667 2.667 0 0 0-3.771.006 2.667 2.667 0 0 0 .008 3.772l3.974 3.96a2.667 2.667 0 0 0 3.766-.001l8.185-8.174a2.667 2.667 0 0 0 .002-3.772 2.667 2.667 0 0 0-1.884-.78zM61.334 96a13.293 13.293 0 0 1 13.332 13.334 13.29 13.29 0 0 1-13.332 13.332A13.293 13.293 0 0 1 48 109.334 13.294 13.294 0 0 1 61.334 96zM56 105.334c-2.193 0-4 1.807-4 4 0 2.195 1.808 4 4 4s4-1.805 4-4c0-2.193-1.807-4-4-4zm10.666 0c-2.193 0-4 1.807-4 4 0 2.195 1.808 4 4 4s4-1.805 4-4c0-2.193-1.807-4-4-4zM56 108c.75 0 1.334.585 1.334 1.334 0 .753-.583 1.332-1.334 1.332-.75 0-1.334-.58-1.334-1.332 0-.75.585-1.334 1.334-1.334zm10.666 0c.75 0 1.334.585 1.334 1.334 0 .753-.583 1.332-1.334 1.332-.75 0-1.332-.58-1.332-1.332 0-.75.583-1.334 1.332-1.334z"
						/>
						<path fill="#79b8ff"
						      d="M109.334 90.666c-9.383 0-17.188 6.993-18.477 16.031a2.667 2.667 0 0 0-.265-.011l-2.7.09a2.667 2.667 0 0 0-2.578 2.751 2.667 2.667 0 0 0 2.752 2.578l2.7-.087a2.667 2.667 0 0 0 .097-.006C92.17 121.029 99.965 128 109.334 128c10.278 0 18.666-8.388 18.666-18.666s-8.388-18.668-18.666-18.668zm0 5.334a13.293 13.293 0 0 1 13.332 13.334 13.29 13.29 0 0 1-13.332 13.332A13.293 13.293 0 0 1 96 109.334 13.294 13.294 0 0 1 109.334 96z"
						/>
					</svg>),
					featured:    true,
				},
			],
		},
		{
			name:         'Database',
			description:  'We design and manage database systems that are the cornerstone of your digital solutions, ensuring fast, secure, and scalable data handling.',
			technologies: [
				{
					name:        'Aurora',
					description: 'AWS\'s high-performance relational database service.',
					icon:        (props) => (<svg viewBox="0 0 256 289"
					                              {...props}>
						<path d="m0 224.742 29.972 35.125 2.695-3.201v-224.666l-2.695-3.395-29.972 35.112z"
						      fill="#1a476f"
						/>
						<path d="m29.976 259.867 57.27 28.633 2.382-3.833.039-281.667-2.381-3-57.31 28.541z"
						      fill="#1f5b98"
						/>
						<path d="m256 63.717-29.98-35.112-3.353 1.062.666 227.333 2.687 2.867 29.98-35.121z"
						      fill="#2d72b8"
						/>
						<path d="m168.75 288.5 57.27-28.633v-231.326l-57.31-28.541-2.71 3.667.039 280.666z"
						      fill="#5294cf"
						/>
						<path d="m87.286 0h81.424v288.504h-81.424z"
						      fill="#2d72b8"
						/>
					</svg>),
				},
				{
					name:        'MySQL',
					description: 'Widely-used open-source relational database system.',
					icon:        (props) => (<svg viewBox="0 0 256 252"
					                              {...props}>
						<path d="M236 194c-14 0-25 1-34 5-3 1-7 1-7 4l3 6c2 3 5 8 9 11l11 8 21 10 11 9 6 4-3-6-5-5c-5-7-11-13-18-18-6-3-18-9-20-15h-1l12-3 18-3 8-2v-2l-9-10c-8-8-18-15-28-22l-18-8c-2-1-6-2-7-4l-7-13-15-30-8-20c-18-30-38-48-68-65-6-4-14-5-22-7l-13-1-8-6C34 5 8-9 1 9c-5 11 7 22 11 28l9 13 3 9c3 8 5 17 9 24l6 10c2 2 4 3 5 6-3 4-3 9-4 13-7 20-4 44 5 59 2 4 9 14 18 10 8-3 6-13 8-22l1-4 8 14c5 9 14 18 22 24 4 3 8 8 13 10l-4-4-9-10c-8-10-14-21-20-32l-7-17-3-6c-3 4-7 7-9 12-3 7-3 17-4 26h-1c-6-1-8-7-10-12-5-12-6-32-1-46 1-4 6-15 4-19-1-3-4-5-6-7l-7-12-10-30-9-13c-3-5-7-8-10-14-1-2-2-5 0-7l2-2c2-2 9 0 11 1 6 3 12 5 17 9l8 6h4c6 1 12 0 17 2 9 3 18 7 25 12 23 14 42 35 54 59 3 4 3 8 5 12l12 26c4 8 7 16 12 23 3 4 14 6 18 8l12 4 18 12c2 2 11 7 12 10Z"
						      fill="#00546B"
						/>
						<path d="m58 43-7 1 6 7 4 9v-1c3-1 4-4 4-8l-2-4-5-4Z"
						      fill="#00546B"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'PlanetScale',
					description: 'Scalable, serverless database platform based on MySQL.',
					icon:        (props) => (<svg viewBox="0 0 256 256"
					                              {...props}>
						<path d="M256 128a128 128 0 01-128 128zM128 0c52 0 96.7 31 116.8 75.5L75.5 244.8c-7.3-3.3-14.2-7.2-20.7-11.7L160 128h-32l-90.5 90.5A128 128 0 01128 0z"
						      fill="#000"
						/>
					</svg>),
				},
				{
					name:        'RDS',
					description: 'AWS\'s relational database service for easier setup and scaling.',
					icon:        (props) => (<svg viewBox="0 0 256 289"
					                              {...props}>
						<path d="m0 224.742 29.972 35.125 2.695-3.201v-224.666l-2.695-3.395-29.972 35.112z"
						      fill="#1a476f"
						/>
						<path d="m29.976 259.867 57.27 28.633 2.382-3.833.039-281.667-2.381-3-57.31 28.541z"
						      fill="#1f5b98"
						/>
						<path d="m256 63.717-29.98-35.112-3.353 1.062.666 227.333 2.687 2.867 29.98-35.121z"
						      fill="#2d72b8"
						/>
						<path d="m168.75 288.5 57.27-28.633v-231.326l-57.31-28.541-2.71 3.667.039 280.666z"
						      fill="#5294cf"
						/>
						<path d="m87.286 0h81.424v288.504h-81.424z"
						      fill="#2d72b8"
						/>
					</svg>),
				},
				{
					name:        'SQL Server',
					description: 'Microsoft\'s enterprise-level relational database management system.',
					icon:        (props) => (<svg viewBox="0 0 48 48"
					                              {...props}>
						<path fill="#cfd8dc"
						      d="M23.084 11.277c-1.633-2.449-1.986-5.722-2.063-7.067-4.148.897-8.269 2.506-8.031 3.691.03.149.218.328.53.502l-.488.873c-.596-.334-.931-.719-1.022-1.179-.269-1.341 1.25-2.554 4.642-3.709a42.152 42.152 0 0 1 4.751-1.279l.597-.12V3.6c0 .042.026 4.288 1.916 7.123l-.832.554zM24.751 43H24.5c-8.192 0-17.309-2.573-18.386-6.879-.657-2.63 1.492-5.536 6.214-8.401l.52.854c-4.249 2.579-6.296 5.172-5.763 7.305.935 3.738 9.575 6.068 17.153 6.12.901-1.347 5.742-9.26 2.979-19.873l.967-.252c3.149 12.092-3.218 20.837-3.282 20.924l-.151.202z"
						/>
						<path fill="#cfd8dc"
						      d="M9.931 39.306c-.539 0-.806-.059-.85-.07a.498.498 0 0 1-.233-.84c.072-.072 7.197-7.208 8.159-12.978l.986.164c-.827 4.964-5.715 10.623-7.656 12.707 1.939-.111 6.835-1.019 16.234-6.28-7.335-.804-8.495-6.676-8.507-6.739l.983-.181c.047.246 1.226 6.011 9.244 6.011h.008a.5.5 0 0 1 .251.933c-11.235 6.509-16.683 7.272-18.619 7.273z"
						/>
						<path fill="#cfd8dc"
						      d="M14.524 41.7a.499.499 0 0 1-.291-.907c.034-.025 1.813-1.338 3.706-4.228a19.896 19.896 0 0 1-2.196-1.137c-.888-.533-1.559-1.105-2.06-1.691-2.57.678-4.942.946-7.025.769l.084-.996c1.876.159 4.009-.063 6.321-.64-1.573-2.688-.129-5.356-.109-5.392l.874.487c-.067.122-1.265 2.37.249 4.633 2.201-.632 4.549-1.567 6.979-2.782a32.189 32.189 0 0 0 1.225-6.276.501.501 0 0 1 .706-.406c.032.015 3.264 1.491 5.604 2.454a.5.5 0 0 1 .091.876 62.494 62.494 0 0 1-6.778 4.042 27.19 27.19 0 0 1-2.459 5.591c3.702 1.383 6.915 1.404 6.956 1.404a.5.5 0 0 1 .243.938c-4.54 2.522-11.767 3.232-12.072 3.261h-.048zm4.385-4.733c-1.04 1.614-2.062 2.773-2.826 3.53 1.998-.294 5.501-.938 8.408-2.139a23.733 23.733 0 0 1-5.582-1.391zm-4.142-3.536c.393.392.883.775 1.49 1.14.736.442 1.483.817 2.22 1.135a26.116 26.116 0 0 0 2.142-4.568c-2.021.962-3.983 1.73-5.852 2.293zm8.435-9.102a33.95 33.95 0 0 1-.913 4.85 62.45 62.45 0 0 0 5.062-3.026 207.1 207.1 0 0 1-4.149-1.824zM17.924 10.6a.504.504 0 0 1-.325-.12c-1.61-1.378-3.505-4.182-3.585-4.301a.5.5 0 0 1 .654-.718c.011.003.938.385 7.217 1.431a.499.499 0 0 1 .29.828c-1.758 1.953-3.979 2.813-4.073 2.848a.527.527 0 0 1-.178.032zm-2.277-3.854c.631.849 1.54 1.996 2.372 2.769a11.186 11.186 0 0 0 2.744-1.798c-2.583-.441-4.159-.755-5.116-.971z"
						/>
						<path fill="#b71c1c"
						      d="M21.843 24.4a.5.5 0 0 1-.497-.552c.292-2.749-3.926-3.852-3.969-3.862a.5.5 0 0 1-.23-.838c.207-.207 5.139-5.098 11.327-7.784a.5.5 0 0 1 .689.559c-1.186 5.744-6.71 12.044-6.944 12.309a.51.51 0 0 1-.376.168zm-3.388-5.115c1.184.445 3.258 1.475 3.783 3.356 1.449-1.808 4.542-5.973 5.697-9.934-4.387 2.11-8.081 5.292-9.48 6.578z"
						/>
						<path fill="#b71c1c"
						      d="m13.079 28.36-.475-.88c1.883-1.015 4.04-2.883 5.807-5.054-1.504 1.03-2.365 1.735-2.392 1.758l-.639-.77c.039-.032 1.764-1.447 4.631-3.22.787-1.266 1.392-2.568 1.703-3.816.053-.212.099-.417.136-.615-1.925-.687-3.701-1.094-4.921-1.269a.5.5 0 0 1-.297-.835c.085-.092 2.116-2.268 4.654-3.463a.5.5 0 0 1 .581.114c.067.073 1.44 1.615 1.091 4.805 1.155.45 2.345.997 3.491 1.648 2.759-1.24 5.892-2.356 9.229-3.03a.51.51 0 0 1 .481.168c.117.14.149.333.083.503-1.3 3.332-4.786 6.891-4.934 7.041a.503.503 0 0 1-.748-.04c-1.12-1.408-2.584-2.574-4.163-3.523a55.136 55.136 0 0 0-5.684 3.049c-2.02 3.153-5.069 6.048-7.634 7.429zm14.413-10.964c1.29.832 2.491 1.81 3.484 2.948.828-.898 2.815-3.168 3.942-5.422-2.65.61-5.158 1.493-7.426 2.474zm-4.693-1.274c-.033.163-.071.33-.113.5-.21.839-.544 1.701-.972 2.561a56.183 56.183 0 0 1 3.618-1.898 25.476 25.476 0 0 0-2.533-1.163zm-4.751-2.45c1.111.218 2.48.574 3.941 1.086.152-1.843-.346-2.972-.647-3.472-1.376.718-2.581 1.728-3.294 2.386z"
						/>
						<path fill="#b71c1c"
						      d="M18.05 18.5c0 4.38-3.65 7.86-6.28 10.4-.44.43-1.93.5-1.93.5.37-.38.79-.78 1.24-1.21 2.5-2.42 5.97-5.73 5.97-9.69 0-4.69-1.89-6.54-3.38-8.02-.66-.67-1.22-1.31-1.56-2.09l.31-.13c.34.15.73.32 1.03.45.24.35.56.69.93 1.06 1.53 1.53 3.67 3.63 3.67 8.73z"
						/>
						<path fill="#b71c1c"
						      d="M42.935 19.794s-.605.086-.775.106c-8.76.97-17.8 3.49-22.97 5.56-1.87.75-3.81 1.66-5.58 2.68-.01.01-.02.01-.04.02-1.04.6-3.57 1.84-5.62 2.93 3-3.19 8.62-5.65 10.86-6.55 5.07-2.03 13.78-4.48 22.35-5.53-1.01-1.18-3.48-3.68-8.34-5.54-2.84-1.1-7.16-1.72-10.97-2.27-6.06-.87-9.51-1.45-9.84-3.1-.07-.33-.02-.66.13-.98.33.54.8.92 1.11 1.14.15.1.26.16.3.18l.01.01c1.42.75 5.25 1.3 8.44 1.76 3.86.56 8.23 1.19 11.18 2.32 6.87 2.65 9.24 6.44 9.34 6.6.09.15.415.664.415.664z"
						/>
					</svg>),
				},
				{
					name:        'SQLite',
					description: 'Lightweight, self-contained SQL database engine.',
					icon:        (props) => (<svg viewBox="0 0 512 228"
					                              {...props}>
						<defs>
							<linearGradient x1="57.7%"
							                y1="2%"
							                x2="57.7%"
							                y2="94.4%"
							                id="sqlite-a"
							>
								<stop stopColor="#97D9F6"
								      offset="0%"
								/>
								<stop stopColor="#0F80CC"
								      offset="92%"
								/>
								<stop stopColor="#0F80CC"
								      offset="100%"
								/>
							</linearGradient>
						</defs>
						<path d="M194.5 112c-6.8 0-12.3 2-16.6 6.1-4.3 4-6.4 9.3-6.4 15.8a23.3 23.3 0 0 0 6.5 17c2.2 2.4 6.6 5.6 13.2 9.7 8 5 13.4 9 16 12 2.5 3.2 3.7 6.4 3.7 9.9 0 4.5-1.5 8.2-4.6 11a18 18 0 0 1-12.4 4 20.1 20.1 0 0 1-20.3-20.8h-2.5v22.9h2.5c.8-2.2 1.8-3.3 3.2-3.3.7 0 2.3.4 4.7 1.3 6 2.1 10.9 3.2 14.7 3.2a23 23 0 0 0 17-7 23.2 23.2 0 0 0 2.4-30.8c-3-4-9-8.6-18-14a59.5 59.5 0 0 1-15-11.3c-2.3-3-3.5-6.1-3.5-9.7 0-3.8 1.5-7 4.2-9.2 2.8-2.3 6.5-3.5 11-3.5 5.2 0 9.5 1.5 12.9 4.6 3.3 3 5.3 7.4 5.9 12.8h2.5V113h-2.3a6 6 0 0 1-.8 2c-.3.3-.7.4-1.4.4a17 17 0 0 1-4.3-1 38.6 38.6 0 0 0-12.3-2.3Zm82.4 0a44.6 44.6 0 0 0-39 22.2 43.5 43.5 0 0 0 4.5 50.2c7 8.2 15.3 13.3 25 15.3 2.1 1.1 5.3 4.1 9.4 9 4.7 5.3 8.6 9.3 11.9 11.6A35.6 35.6 0 0 0 311 227c5.3 0 10-.9 14-2.7l-.9-2.3a20.1 20.1 0 0 1-18.7-2.3c-3.6-2.5-8.3-7.1-13.8-14a47.6 47.6 0 0 0-5.4-6.1c10.6-2 19.3-7.2 26-15.4a42.8 42.8 0 0 0 10.2-28 42 42 0 0 0-13.2-31.4 44.8 44.8 0 0 0-32.4-12.9Zm51.4 0 .1 2.7c5.5 0 8.6 1.7 9.3 5 .3 1.1.4 3.3.4 6.4v59.6c0 4.5-.7 7.3-2 8.6-1.1 1.2-3.2 2-6.2 2.3l-.1 2.6h55.1l1.4-13.5h-2.5c-.7 3.7-2.3 6.3-5 7.8a30.5 30.5 0 0 1-14 2.3h-5.2c-6 0-9.5-2.2-10.5-6.6-.2-.9-.2-1.8-.2-2.8l.2-60.3c0-4.4.5-7.4 1.7-8.9 1.2-1.4 3.3-2.3 6.4-2.5l-.2-2.7h-28.7Zm-50.6 3.3a28 28 0 0 1 23 11.2 48 48 0 0 1 8.8 30.5c0 12.3-3 22.1-8.9 29.5a29 29 0 0 1-23.7 11c-9.5 0-17.2-3.8-23-11.4a47.1 47.1 0 0 1-8.9-29.6c0-12.5 3-22.5 9-30 5.9-7.5 13.8-11.2 23.7-11.2Zm126.9 12.8c-1.3 0-2.4.5-3.1 1.4-.8 1-1 2-.8 3.4a6 6 0 0 0 2.2 3.4c1.1 1 2.4 1.4 3.7 1.4 1.3 0 2.3-.5 3-1.4.7-1 1-2.1.7-3.4-.3-1.4-1-2.5-2-3.4a5.6 5.6 0 0 0-3.7-1.4Zm36.4 9.2c-2.3 8.8-7.3 13.5-14.9 14.3l.1 2.5h8.9l-.2 29.8c0 5.1.2 8.5.5 10.2 1 4.2 3.6 6.3 8.1 6.3 6.6 0 13.4-4 20.6-12l-2.2-1.8c-5.2 5.2-9.7 7.8-13.7 7.8-2.5 0-4-1.4-4.6-4.2l-.2-2.4v-33.7h13.7l-.2-4h-13.4v-12.8H441Zm52.4 11.2c-7.6 0-13.7 3.7-18.5 11a31.3 31.3 0 0 0-4.4 24.4 21 21 0 0 0 6.7 12.2 19 19 0 0 0 12.7 4.3c4.7 0 11.4-1.2 14.1-3.7 2.8-2.4 5.4-6.3 7.8-11.7l-2-2a20.6 20.6 0 0 1-17.1 10.5c-8 0-12.8-4.3-14.6-13l-.5-3.5a46 46 0 0 0 21.4-8c4.8-3.8 9.6-7.9 8.7-12.1a9.9 9.9 0 0 0-3.9-6c-2-1.6-7.4-2.4-10.4-2.4Zm-83 .3-16.3 3.8v2.9l5.7-.7c2.7 0 4.3 1.2 4.8 3.7.2.8.3 2 .4 3.4l-.2 26.8c0 3.7-.5 5.8-1.3 6.5-.8.6-3 1-6.6 1v2.5h25.9v-2.5c-3.7 0-6-.3-7-.9-1-.5-1.8-1.5-2.1-3-.2-1.2-.3-3.1-.4-5.7l.1-37.8h-3Zm78.9 5c1.6 0 3 .6 4.6 1.8a7 7 0 0 1 2.8 4c1.4 7-4.9 12-19 14.7a25 25 0 0 1 2.7-14.1c2.3-4.3 5.3-6.4 8.9-6.4Z"
						      fill="#003B57"
						/>
						<path d="M157.9 10H17C7.7 10 0 17.7 0 27v155.2c0 9.4 7.7 17.2 17.1 17.2h92.7c-1-46.2 14.7-135.7 48-189.5Z"
						      fill="#0F80CC"
						/>
						<path d="M152.8 15H17C10.5 15 5 20.4 5 27V171c30.7-11.8 76.8-22 108.7-21.5a989.7 989.7 0 0 1 39-134.5Z"
						      fill="url(#sqlite-a)"
						/>
						<path d="M190.7 4.9c-9.6-8.6-21.3-5.2-32.8 5a81.4 81.4 0 0 0-5.1 5c-19.7 21-38 59.7-43.7 89.2a81.5 81.5 0 0 1 5.8 17.7l.8 3.5-.9-2.8a173.8 173.8 0 0 0-.8-2 172 172 0 0 0-6.4-12.1l-3.5 11c4.5 8.2 7.3 22.4 7.3 22.4l-1.4-4.1c-1-2.9-6-11.7-7.2-13.7-2 7.5-2.8 12.6-2.1 13.8 1.4 2.4 2.7 6.5 4 11a257.6 257.6 0 0 1 4.6 25c-.3 8.6-.1 17.6.5 25.7a91 91 0 0 0 4.7 24.8l1.5-.8a111 111 0 0 1-3.9-37c.9-22.5 6-49.5 15.6-77.7 16-42.5 38.4-76.6 58.8-93-18.6 17-43.8 71.4-51.4 91.6a365.7 365.7 0 0 0-18 64c6.2-19 26.4-27.2 26.4-27.2s9.8-12.2 21.4-29.6a210 210 0 0 0-22.1 6l-7.1 3s18.1-11 33.7-16C191 73.8 214.2 25.9 190.7 4.9"
						      fill="#003B57"
						/>
					</svg>),
				},
			],
		},
		{
			name:         'Third parties',
			description:  'We expertly integrate third-party services to enrich your applications, adding functionalities that elevate user experience and operational efficiency.',
			technologies: [
				{
					name:        'Algolia',
					description: 'Search-as-a-service platform for fast, scalable search solutions.',
					icon:        (props) => (<svg viewBox="0 0 120 120"
					                              {...props}>
						<path d="M15.8 0h88.4c8.7 0 15.8 7.1 15.8 15.8v88.4c0 8.7-7.1 15.8-15.8 15.8H15.8C7.1 120 0 112.9 0 104.2V15.8C0 7.1 7.1 0 15.8 0"
						      fill="#5468ff"
						/>
						<path d="M72.5 26.8v-4.1c0-2.9-2.3-5.2-5.2-5.2H55.2c-2.9 0-5.2 2.3-5.2 5.2v4.2c0 .5.4.8.9.7 3.4-1 7-1.5 10.6-1.5 3.5 0 6.9.5 10.2 1.4.4.1.8-.2.8-.7m-33.3 5.4-2.1-2.1c-2-2-5.3-2-7.4 0l-2.5 2.5c-2 2-2 5.3 0 7.3l2 2c.3.3.8.2 1.1-.1 1.2-1.7 2.5-3.2 4-4.7s3-2.8 4.7-4c.5-.1.5-.6.2-.9m22.2 13V63c0 .5.5.9 1 .6l15.8-8.2c.4-.2.5-.6.3-1-3.3-5.8-9.4-9.7-16.4-9.9-.4 0-.7.3-.7.7m0 42.9c-13.2 0-23.9-10.7-23.9-23.9s10.7-23.9 23.9-23.9S85.3 51 85.3 64.2 74.6 88.1 61.4 88.1m0-57.8c-18.7 0-33.9 15.2-33.9 33.9s15.2 33.9 33.9 33.9 33.9-15.2 33.9-33.9-15.1-33.9-33.9-33.9"
						      fill="#fff"
						/>
					</svg>),
				},
				{
					name:        'Fathom Analytics',
					description: 'Privacy-focused, simple web analytics tool.',
					icon:        (props) => (<svg viewBox="0 0 67.851 50"
					                              {...props}>
						<g transform="translate(11882.544 12524.362)">
							<path d="M81.249,324.048H78.86a1.962,1.962,0,0,0-1.855,1.318l-14.9,42.741a1.963,1.963,0,0,0,1.855,2.61h2.388a1.963,1.963,0,0,0,1.854-1.317l14.9-42.741a1.964,1.964,0,0,0-1.854-2.611"
							      transform="translate(-11897.906 -12845.645)"
							      fill="#9580ff"
							/>
							<path d="M14.677,336.886v-1.948a1.964,1.964,0,0,0-1.963-1.964H8.957v-1.805c-.006-2.11.471-3.374.9-3.834l.02-.025a2.2,2.2,0,0,1,1.061-.579,25.624,25.624,0,0,1,4.2-.325h.722a1.964,1.964,0,0,0,1.963-1.964v-1.76a1.96,1.96,0,0,0-1.588-1.928c-.238-.046-.5-.093-.8-.138-.371-.057-2.317-.085-2.7-.086h-.027c-3.163,0-5.856.739-7.66,2.674l0,0c-1.762,1.941-2.4,4.687-2.4,8.023V368A1.964,1.964,0,0,0,4.6,369.962H6.993A1.962,1.962,0,0,0,8.957,368V338.849h3.756a1.962,1.962,0,0,0,1.963-1.963"
							      transform="translate(-11885.184 -12844.891)"
							      fill="hsla(60, 3%, 20%, 1)"
							/>
							<path d="M43.125,337.381a14.827,14.827,0,0,0-7.629-1.813,17.368,17.368,0,0,0-7.612,1.546A12.219,12.219,0,0,0,22.7,341.75l-.009.013a1.694,1.694,0,0,0-.254.895,1.792,1.792,0,0,0,1.2,1.684h0l1.927.686a2.748,2.748,0,0,0,3.053-.863,7.86,7.86,0,0,1,.582-.637c1.261-1.224,3.132-1.945,6.044-1.956a10.514,10.514,0,0,1,3.686.574,5.038,5.038,0,0,1,2.175,1.529c1.091,1.339,1.778,3.408,1.842,6.374-2.806.044-5.3.161-7.446.362a34.983,34.983,0,0,0-7.946,1.654h0l-.009,0-.023.006,0,0a12.629,12.629,0,0,0-6.1,3.776,10.233,10.233,0,0,0-2.216,6.72v.064a10.849,10.849,0,0,0,1.67,6.015,10.4,10.4,0,0,0,4.665,3.87,16.69,16.69,0,0,0,6.692,1.232,15.255,15.255,0,0,0,5.159-.965,16.393,16.393,0,0,0,5.07-2.992c.3-.251.573-.52.843-.8a9.263,9.263,0,0,0,1.146,3.251,1.95,1.95,0,0,0,1.673.935h0l1.149-.013a1.964,1.964,0,0,0,1.941-1.963V350.166a18.409,18.409,0,0,0-1.426-7.523,11.334,11.334,0,0,0-4.662-5.262m-1.6,24.9a11.575,11.575,0,0,1-3.878,4.041,9.525,9.525,0,0,1-5.235,1.486,7.992,7.992,0,0,1-5.25-1.5,4.367,4.367,0,0,1-1.228-1.59,5.665,5.665,0,0,1-.42-2.242,5.093,5.093,0,0,1,.655-2.579,5.261,5.261,0,0,1,2.41-1.934,22.124,22.124,0,0,1,6.1-1.587,68.356,68.356,0,0,1,8.281-.581v1.215a10.274,10.274,0,0,1-1.432,5.269"
							      transform="translate(-11888.733 -12848.114)"
							      fill="hsla(60, 3%, 20%, 1)"
							/>
						</g>
					</svg>),
				},
				{
					name:        'Pusher',
					description: 'Real-time communication and collaboration APIs.',
					icon:        (props) => (<svg viewBox="0 0.1599999999999997 256.02071143641297 395.0285944836734"
					                              {...props}>
						<path d="M127.995 394.55v-99.047c0-.208.114-.416.312-.52l127.391-73.49a.573.573 0 0 0 .302-.52v-28.157a.583.583 0 0 0-.884-.52l-126.227 72.825a.582.582 0 0 1-.884-.52v-28.177c0-.208.104-.406.291-.51l127.402-73.49a.615.615 0 0 0 .302-.52v-28.157a.604.604 0 0 0-.884-.52l-126.227 72.815a.582.582 0 0 1-.894-.51v-28.167c0-.208.114-.405.312-.51l127.391-73.458a.583.583 0 0 0 .302-.52V74.346a1.25 1.25 0 0 0-.583-1.02L128.587.16a1.165 1.165 0 0 0-1.175 0L103.29 14.08a.582.582 0 0 0 0 1.02l126.227 72.814a.603.603 0 0 1 0 1.019l-24.123 13.912c-.37.2-.815.2-1.185 0L77.39 29.698a1.248 1.248 0 0 0-1.247 0L52.092 43.6a.582.582 0 0 0 0 1.019l126.206 72.825a.582.582 0 0 1 0 1.03l-24.122 13.911a1.248 1.248 0 0 1-1.248 0L26.192 59.217a1.248 1.248 0 0 0-1.248 0L0 73.65v247.744c0 .208.104.416.302.51l24.413 14.088a.582.582 0 0 0 .884-.52V89.453a.582.582 0 0 1 .884-.51l24.434 14.09c.166.104.28.301.28.52v247.37c0 .207.105.415.292.519l24.414 14.1a.603.603 0 0 0 .904-.52v-246.05a.582.582 0 0 1 .884-.52l24.414 14.079a.603.603 0 0 1 .301.52v247.41a.62.62 0 0 0 .28.52l24.487 14.069a.582.582 0 0 0 .832-.51z"
						      fill="#300d4f"
						/>
					</svg>),
				},
				{
					name:        'Sentry',
					description: 'Application monitoring and error tracking software.',
					icon:        (props) => (<svg viewBox="0 0 72 66"
					                              {...props}>
						<path d="M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z"
						      transform="translate(11, 11)"
						      fill="#362d59"
						></path>
					</svg>),
				},
				{
					name:        'Stripe',
					description: 'Online payment processing for internet businesses.',
					icon:        (props) => (<svg viewBox="0 0 512 214"
					                              {...props}>
						<path d="M512 110.08c0-36.409-17.636-65.138-51.342-65.138c-33.85 0-54.33 28.73-54.33 64.854c0 42.808 24.179 64.426 58.88 64.426c16.925 0 29.725-3.84 39.396-9.244v-28.445c-9.67 4.836-20.764 7.823-34.844 7.823c-13.796 0-26.027-4.836-27.591-21.618h69.547c0-1.85.284-9.245.284-12.658m-70.258-13.511c0-16.071 9.814-22.756 18.774-22.756c8.675 0 17.92 6.685 17.92 22.756zm-90.31-51.627c-13.939 0-22.899 6.542-27.876 11.094l-1.85-8.818h-31.288v165.83l35.555-7.537l.143-40.249c5.12 3.698 12.657 8.96 25.173 8.96c25.458 0 48.64-20.48 48.64-65.564c-.142-41.245-23.609-63.716-48.498-63.716m-8.534 97.991c-8.391 0-13.37-2.986-16.782-6.684l-.143-52.765c3.698-4.124 8.818-6.968 16.925-6.968c12.942 0 21.902 14.506 21.902 33.137c0 19.058-8.818 33.28-21.902 33.28M241.493 36.551l35.698-7.68V0l-35.698 7.538zm0 10.809h35.698v124.444h-35.698zm-38.257 10.524L200.96 47.36h-30.72v124.444h35.556V87.467c8.39-10.951 22.613-8.96 27.022-7.396V47.36c-4.551-1.707-21.191-4.836-29.582 10.524m-71.112-41.386l-34.702 7.395l-.142 113.92c0 21.05 15.787 36.551 36.836 36.551c11.662 0 20.195-2.133 24.888-4.693V140.8c-4.55 1.849-27.022 8.391-27.022-12.658V77.653h27.022V47.36h-27.022zM35.982 83.484c0-5.546 4.551-7.68 12.09-7.68c10.808 0 24.461 3.272 35.27 9.103V51.484c-11.804-4.693-23.466-6.542-35.27-6.542C19.2 44.942 0 60.018 0 85.192c0 39.252 54.044 32.995 54.044 49.92c0 6.541-5.688 8.675-13.653 8.675c-11.804 0-26.88-4.836-38.827-11.378v33.849c13.227 5.689 26.596 8.106 38.827 8.106c29.582 0 49.92-14.648 49.92-40.106c-.142-42.382-54.329-34.845-54.329-50.774"
						      fill="#635BFF"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'Twilio',
					description: 'Cloud communications platform for building SMS and voice applications.',
					icon:        (props) => (<svg viewBox="0 0 64 64"
					                              {...props}>
						<g transform="translate(0 .047) scale(.93704)"
						   fill="#e31e26"
						>
							<path d="M34.1 0C15.3 0 0 15.3 0 34.1s15.3 34.1 34.1 34.1C53 68.3 68.3 53 68.3 34.1S53 0 34.1 0zm0 59.3C20.3 59.3 9 48 9 34.1 9 20.3 20.3 9 34.1 9 48 9 59.3 20.3 59.3 34.1 59.3 48 48 59.3 34.1 59.3z" />
							<circle cx="42.6"
							        cy="25.6"
							        r="7.1"
							/>
							<circle cx="42.6"
							        cy="42.6"
							        r="7.1"
							/>
							<circle cx="25.6"
							        cy="42.6"
							        r="7.1"
							/>
							<circle cx="25.6"
							        cy="25.6"
							        r="7.1"
							/>
						</g>
					</svg>),
				},
			],
		},
		{
			name:         'Packages',
			description:  'In our development process, we incorporate top-quality software packages, carefully selected to introduce innovative features and streamline your application\'s functionality.',
			technologies: [
				{
					name:        'Cashier',
					description: 'Interface for subscription billing services.',
					icon:        (props) => (<svg viewBox="0 0 90 62"
					                              {...props}>
						<g transform="translate(0 1)">
							<linearGradient id="cashier-a"
							                gradientUnits="userSpaceOnUse"
							                x1="-761.764"
							                y1="730.714"
							                x2="-761.764"
							                y2="729.714"
							                gradientTransform="matrix(72 0 0 -42 54883 30709)"
							>
								<stop offset="0"
								      stopColor="#a7da3e"
								/>
								<stop offset="1"
								      stopColor="#7ed321"
								/>
							</linearGradient>
							<path d="M5 19h62c2.8 0 5 2.2 5 5v32c0 2.8-2.2 5-5 5H5c-2.8 0-5-2.2-5-5V24c0-2.8 2.2-5 5-5z"
							      fillRule="evenodd"
							      clipRule="evenodd"
							      fill="url(#cashier-a)"
							/>
							<circle className="st1"
							        cx="36"
							        cy="40"
							        r="12"
							/>
							<linearGradient id="cashier-b"
							                gradientUnits="userSpaceOnUse"
							                x1="-761.764"
							                y1="730.714"
							                x2="-761.764"
							                y2="729.714"
							                gradientTransform="matrix(72 0 0 -42 54901 30689)"
							>
								<stop offset="0"
								      stopColor="#699b0a"
								/>
								<stop offset="1"
								      stopColor="#417505"
								/>
							</linearGradient>
							<path d="M23-1h62c2.8 0 5 2.2 5 5v32c0 2.8-2.2 5-5 5H23c-2.8 0-5-2.2-5-5V4c0-2.8 2.2-5 5-5z"
							      fillRule="evenodd"
							      clipRule="evenodd"
							      fill="url(#cashier-b)"
							/>
							<circle className="st1"
							        cx="54"
							        cy="20"
							        r="12"
							/>
						</g>
					</svg>),
					featured:    true,
				},
				{
					name:        'Horizon',
					description: 'Tool for queue monitoring and configuration.',
					icon:        (props) => (<svg viewBox="0 0 48 48"
					                              {...props}>
						<path d="M8.4 42.3C3.1 37.7 0 31 0 24c0-6.6 2.7-12.6 7-17 9.4-9.3 24.6-9.3 34 0s9.4 24.6 0 33.9c-8.9 8.9-23.1 9.5-32.6 1.4zM6.5 25.5C9.1 23.1 11 20 16 20c8 0 8 8 16 8 5 0 6.9-3.1 9.5-5.5-.8-9.7-9.3-16.9-19-16.1s-16.9 9.4-16 19.1z"
						      fill="#405263"
						/>
					</svg>),
				},
				{
					name:        'Octane',
					description: 'Supercharges performance by keeping the application in memory.',
					icon:        (props) => (<svg viewBox="0 0 48 47.9"
					                              {...props}>
						<path d="m4.5 10.8-3.8 10c-.9 2.5-.9 5.2.2 7.6l4.4 9.8c1.1 2.4 3.1 4.3 5.5 5.2l10.1 3.9c2.5.9 5.2.9 7.6-.2l9.8-4.4c2.4-1.1 4.3-3.1 5.2-5.5l3.9-10.1c.9-2.5.9-5.2-.2-7.6l-4.4-9.8c-1.1-2.4-3.1-4.3-5.5-5.2L27.2.7c-2.5-.9-5.2-.9-7.6.2L9.8 5.2c-2.5 1.1-4.3 3.1-5.3 5.6z"
						      fill="#dc2626"
						/>
						<path d="m5.5 15.3 27.1-9.9 9.9 27.1-27.1 9.9-9.9-27.1z"
						      fill="#991b1b"
						/>
						<path d="m7.3 12.3 28.4-5 5 28.4-28.4 5-5-28.4z"
						      fill="#fff"
						/>
					</svg>),
				},
				{
					name:        'Pennant',
					description: 'Feature flags for releasing early and often.',
					icon:        (props) => (<svg viewBox="0 0 77 64"
					                              {...props}>
						<path d="M67 32v1.7L8.3 49.6C-1.4 34.8 2.7 15 17.4 5.3S52-.3 61.7 14.4C65.2 19.6 67 25.8 67 32zM35 64c14.6 0 27.4-9.9 31-24L12.2 54.5C18.3 60.6 26.5 64 35 64z"
						      fill="#99d1a4"
						/>
						<path fill="#1aa44a"
						      d="M3 52V12l74 20z"
						/>
						<path d="M7 15v34l-4 3v-7.5H0v-5h3v-15H0v-5h3V12l4 3z"
						      fill="#17542e"
						/>
					</svg>),
				},
				{
					name:        'Pest',
					description: 'Testing framework with a focus on simplicity and flexibility.',
					icon:        (props) => (<svg viewBox="0 0 900 204"
					                              {...props}>
						<path d="M227.3 57.9c5.6-31.9-15.7-57.9-47.5-57.9h-144l-10.2 57.9h144l-3.4 19.3h-144l-22.2 126.8h57.6l12.1-69h86.4c31.8 0 62.2-26 67.8-57.9l3.4-19.2zM396.6 77.8h-153.1l-9 48.4h153zM458.2 0h-201.6l-10.2 58h201.7zM220.8 204h201.7l10.1-58h-201.6zM535 0c-31.4 0-61.7 26.5-67.8 58l-1.7 9.7h.1c-3.9 30.8 16.7 57 47.6 57h86.4l-3.8 21.3h-144l-10.2 58h144c31.8 0 62.2-26 67.8-58l3.7-21.3c5.6-32-15.7-58-47.5-58h-86.4l1.5-8.7h192.1l-25.6 146h57.8l25.6-146h57.6c31.8 0 62.2-26 67.8-58h-365z" />
					</svg>),
				},
				{
					name:        'Sail',
					description: 'Command-line interface for managing Docker environments.',
					icon:        (props) => (<svg viewBox="0 0 64 64"
					                              {...props}>
						<defs>
							<circle id="sail-a"
							        cx="32"
							        cy="32"
							        r="32"
							/>
						</defs>
						<clipPath id="sail-b">
							<use href="#sail-a"
							     overflow="visible"
							/>
						</clipPath>
						<g clipPath="url(#sail-b)">
							<path d="M0 0h64v64H0V0z"
							      fill="#38bdf7"
							/>
							<path d="m58 50.7-26-40V64h26V50.7z"
							      fill="#0d4a6e"
							/>
							<path d="M8 53.1V64h21.3V24L8 53.1z"
							      fill="#e0f2fe"
							/>
						</g>
					</svg>),
					featured:    true,
				},
				{
					name:        'Sanctum',
					description: 'Lightweight authentication system for SPAs and simple APIs.',
					icon:        (props) => (<svg viewBox="0 0 60 60"
					                              {...props}>
						<circle cx="30"
						        cy="30"
						        r="8"
						        fill="#1c5872"
						/>
						<linearGradient id="sanctum-a"
						                gradientUnits="userSpaceOnUse"
						                x1="14"
						                y1="62"
						                x2="14"
						                y2="2"
						                gradientTransform="matrix(1 0 0 -1 0 62)"
						>
							<stop offset="0"
							      stopColor="#7be7ee"
							/>
							<stop offset="1"
							      stopColor="#18caf1"
							/>
						</linearGradient>
						<path d="M19.1 0H28v12h-8l-8 8v20l8 8h8v12h-8.9c-2.7 0-5.2-1.1-7.1-2.9L2.9 48C1.1 46.1 0 43.5 0 40.9V38h4c1.1 0 2-.9 2-2s-.9-2-2-2H0v-8h4c1.1 0 2-.9 2-2s-.9-2-2-2H0v-2.9c0-2.7 1.1-5.2 2.9-7.1L12 2.9C13.9 1.1 16.5 0 19.1 0z"
						      fill="url(#sanctum-a)"
						/>
						<linearGradient id="sanctum-b"
						                gradientUnits="userSpaceOnUse"
						                x1="46"
						                y1="62"
						                x2="46"
						                y2="2"
						                gradientTransform="matrix(1 0 0 -1 0 62)"
						>
							<stop offset="0"
							      stopColor="#7be7ee"
							/>
							<stop offset="1"
							      stopColor="#18caf1"
							/>
						</linearGradient>
						<path d="M32 60V48h8l8-8V20l-8-8h-8V0h8.9c2.7 0 5.2 1.1 7.1 2.9l9.1 9.1c1.9 1.9 2.9 4.4 2.9 7.1V22h-4c-1.1 0-2 .9-2 2s.9 2 2 2h4v8h-4c-1.1 0-2 .9-2 2s.9 2 2 2h4v2.9c0 2.7-1.1 5.2-2.9 7.1L48 57.1C46.1 59 43.6 60 40.9 60H32z"
						      fill="url(#sanctum-b)"
						/>
					</svg>),
					featured:    true,
				},
				{
					name:        'Scout',
					description: 'Laravel\'s full-text search solution.',
					icon:        (props) => (<svg viewBox="0 0 80 80"
					                              {...props}>
						<linearGradient id="scout-a"
						                gradientUnits="userSpaceOnUse"
						                x1="-784.563"
						                y1="748.55"
						                x2="-784.563"
						                y2="747.55"
						                gradientTransform="matrix(80 0 0 -80 62805 59884)"
						>
							<stop offset="0"
							      stopColor="#f1cf88"
							/>
							<stop offset="1"
							      stopColor="#f65a5a"
							/>
						</linearGradient>
						<path d="m0 48 40 22 40-22v10L40 80 0 58V48zM0 0l40 22L80 0v38L40 60 0 38V0z"
						      fill="url(#scout-a)"
						/>
					</svg>),
				},
				{
					name:        'Socialite',
					description: 'OAuth authentication package for social networks.',
					icon:        (props) => (<svg viewBox="0 0 64 66"
					                              {...props}>
						<linearGradient id="socialite-a"
						                gradientUnits="userSpaceOnUse"
						                x1="-131.438"
						                y1="424.545"
						                x2="-131.438"
						                y2="423.545"
						                gradientTransform="matrix(64 0 0 -66 8444 28020)"
						>
							<stop offset="0"
							      stopColor="#e99cb7"
							/>
							<stop offset="1"
							      stopColor="#bc62ce"
							/>
						</linearGradient>
						<path d="M28 58.8V32L0 4V0h64v4L36 32v26.8L52 62v4H12v-4l16-3.2zm14-42.5c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6z"
						      fillRule="evenodd"
						      clipRule="evenodd"
						      fill="url(#socialite-a)"
						/>

					</svg>),
				},
			],
		},
	];

	return (<PrimaryLayout pageTitle="Our Tech Stack">
		<div className="bg-teal-500 relative">
			<GradientTransition direction="up"
			                    from="from-teal-600"

			/>

			<Container className="py-16 relative text-teal-50">
				<h1 className="text-4xl font-bold lowercase text-white">
					Our tech stack
				</h1>

				<p className="mt-12 font-medium text-base">
					Our expertise with these tools and technologies uniquely positions us to assist with your
					project, ensuring that you love the final result.
				</p>

				<p className="mt-2 font-medium text-base">
					A <HeartIcon className="inline mx-2 h-6 w-6 text-red-500" />
					means we love using this technology the most.
				</p>

				<div className="mt-16 grid gap-y-6 lg:grid-cols-3 lg:gap-x-16 lg:gap-y-32 xl:grid-cols-4">
					{categories.map((category) => {
						return (<Fragment key={category.name}>
							<div className="space-y-2">
								<h2 className="text-lg font-bold">{category.name}</h2>

								<p className="text-base font-medium">{category.description}</p>
							</div>

							<div className="px-3 gap-6 lg:col-span-2 xl:col-span-3 grid lg:grid-cols-2 xl:grid-cols-3 lg:gap-12">
								{category.technologies.map((item) => {
									return (<div className={classNames([
										'group relative p-4 rounded-lg bg-teal-50 shadow-lg shadow-teal-700 hover:shadow-2xl hover:shadow-teal-700 hover:scale-105 lg:hover:scale-110 transform duration-300 flex gap-4 flex-row items-start select-none hover:bg-gradient-to-br hover:from-white hover:to-teal-300/25',
										item.className ?? '',
									])}
									             key={item.name}
									>
										<item.icon className={classNames([
											'flex-shrink-0 h-16 w-16',
											(item.featured ?? false) ? '' : 'grayscale group-hover:grayscale-0',
										])}
										           aria-hidden="true"
										/>

										<div className="space-y-2">
											<h3 className="text-lg font-bold text-teal-900 leading-none">
												{item.name}
											</h3>

											<p className="text-sm text-gray-700 whitespace-pre-wrap">{item.description}</p>
										</div>

										{(item.featured ?? false) &&
											<HeartIcon className="absolute top-4 right-4 h-6 w-6 text-red-500" />}
									</div>);
								})}
							</div>
						</Fragment>);
					})}
				</div>
			</Container>
		</div>
	</PrimaryLayout>);
}
